import { UserAuditLogEntry } from '../types/auditLogs.types';
import { EnrichmentMaps } from '../types/enrichment.types';

/**
 * Resolves the user ids referenced by a user audit-log entry to human-readable
 * names using the enrichment maps: the entry's author (so attributable events
 * can show "by <name>"), a conversation-assigned entry's requester, and an
 * agent ban/unban entry's target end user.
 */
export function enrichUserAuditLogEntry(
  entry: UserAuditLogEntry,
  { users }: EnrichmentMaps,
): UserAuditLogEntry {
  const authorName = users[entry.author.id]?.name;
  const enriched = authorName
    ? { ...entry, author: { ...entry.author, name: authorName } }
    : entry;

  if (
    enriched.activity_type === 'CONVERSATION_ASSIGNED' &&
    enriched.contact_id
  ) {
    return { ...enriched, contact_name: users[enriched.contact_id]?.name };
  }

  if (
    (enriched.activity_type === 'AGENT_BANNED_USER' ||
      enriched.activity_type === 'AGENT_UNBANNED_USER') &&
    enriched.user_id
  ) {
    return { ...enriched, user_name: users[enriched.user_id]?.name };
  }

  return enriched;
}
